import ExpiredLinkPanel from './errors/ExpiredLinkPanel'
import { AccountNotFound } from './errors/AccountNotFound'
import * as React from 'react'
import useExpiredLinkPanel, { AuthError, INVITE_LINK_EXPIRED_CODES } from './useExpiredLinkPanel'
import { useAppSelector } from '../../store/hooks'
import { selectAuthErrors } from '../../store/auth/authSlice'
import { UnexpectedError } from './errors/UnexpectedError'
import { LoginHeader } from './headers/LoginHeader'
import { SignupHeader } from './headers/SignupHeader'
import { ERROR_ACCOUNT_NOT_FOUND } from '../../common/errorCodes'

interface LoginErrorPanelProps {
  codes?: number[]
}

export const LoginErrorPanel = ({ codes = INVITE_LINK_EXPIRED_CODES }: LoginErrorPanelProps) => {
  const authErrors = useAppSelector(selectAuthErrors)
  const expiredLinkPanel = useExpiredLinkPanel(authErrors, codes)

  if (!authErrors) return null

  const firstError = authErrors[0] as AuthError | undefined
  const errorCode = firstError?.errorCode
  const email = firstError?.email
  const errorMessage = firstError?.message ?? ''

  if (expiredLinkPanel) {
    return (
      <div className='auth-container'>
        <ExpiredLinkPanel {...expiredLinkPanel} />
      </div>
    )
  }

  if (errorCode === ERROR_ACCOUNT_NOT_FOUND) {
    return (
      <div className='auth-container'>
        <SignupHeader />
        <AccountNotFound email={email} />
      </div>
    )
  }

  return (
    <div className='auth-container'>
      <LoginHeader />
      <UnexpectedError errorMessage={errorMessage} errorCode={errorCode ? String(errorCode) : null} />
    </div>
  )
}
